/**
 * @desc 物流报价方案-附加费用更新
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.LogisticsQuotationSurchargeInfoUpdateDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/tms/logisticsQuotation/quotationSurcharge/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
